import _classCallCheck from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module ui/list/listitemgroupview
 */
import View from '../view.js';
import ListView from './listview.js';
import LabelView from '../label/labelview.js';
import ListSeparatorView from './listseparatorview.js';
/**
 * The list item group view class.
 */
var ListItemGroupView = /*#__PURE__*/function (_View) {
  _inherits(ListItemGroupView, _View);
  var _super = _createSuper(ListItemGroupView);
  /**
   * Creates an instance of the list item group view class.
   *
   * @param locale The {@link module:core/editor/editor~Editor#locale} instance.
   * @param labelView The instance of the group's label. If not provided, an instance of
   * {@link module:ui/label/labelview~LabelView} is used.
   */
  function ListItemGroupView(locale) {
    var _this;
    var labelView = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new LabelView();
    _classCallCheck(this, ListItemGroupView);
    _this = _super.call(this, locale);
    var bind = _this.bindTemplate;
    var nestedList = new ListView(locale);
    _this.set({
      label: '',
      isVisible: true
    });
    _this.labelView = labelView;
    _this.labelView.bind('text').to(_assertThisInitialized(_this), 'label');
    _this.children = _this.createCollection();
    _this.children.addMany([_this.labelView, nestedList]);
    nestedList.set({
      role: 'group',
      ariaLabelledBy: labelView.id
    });
    // Disable focus tracking and accessible navigation in the child list.
    nestedList.focusTracker.destroy();
    nestedList.keystrokes.destroy();
    _this.items = nestedList.items;
    _this.setTemplate({
      tag: 'li',
      attributes: {
        role: 'presentation',
        class: ['ck', 'ck-list__group', bind.if('isVisible', 'ck-hidden', function (value) {
          return !value;
        })]
      },
      children: _this.children
    });
    return _this;
  }
  /**
   * Focuses the list item (which is not a separator).
   */
  _createClass(ListItemGroupView, [{
    key: "focus",
    value: function focus() {
      if (this.items) {
        var firstListItem = this.items.find(function (item) {
          return !(item instanceof ListSeparatorView);
        });
        if (firstListItem) {
          firstListItem.focus();
        }
      }
    }
  }]);
  return ListItemGroupView;
}(View);
export { ListItemGroupView as default };